// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"444":"76c11778","585":"4886f12c","737":"4886f12c","983":"76c11778"}[chunkId] + ".chunk.css";
};